<template>
	<div class="home-container">
		<div class="hero">
			<h1 class="title">AppWAFN - App Without A Fancy Name</h1>
			<h2 class="subtitle">The Structured Registry of all things - Organized from the Get-Go</h2>
		</div>

		<div class="description">

			<div class="feature-box">
				<p>
					You can search for any or all fields of an Object.
					For example, a Person with the First Name <strong>Terry</strong> and Last Name <strong>Fox</strong>.
					<strong>Terry</strong> and <strong>Fox</strong> are two disctinct fields in the data and can be searched as such.
				</p>
				<p>
					Multiple criteria creates a powerful search. This is an important feature.
					Any search criteria can be saved. This is the closest thing to an algorithm but it is defined by the user, and loads it only if requested.
				</p>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'HomeView'
	}
</script>

<style scoped>
	.home-container {
		max-width: 900px;
		margin: 0 auto;
		padding: 40px 20px;
		text-align: center;
		color: #2c3e50;
	}
	.hero {
		margin-bottom: 40px;
	}
	.title {
		font-size: 2.5rem;
		margin-bottom: 10px;
	}
	.subtitle {
		font-size: 1.2rem;
		font-weight: normal;
		color: #666;
	}
	.description {
		font-size: 1.1rem;
		line-height: 1.6;
		text-align: left;
	}
	.feature-box {
		margin-top: 30px;
		padding: 20px;
		background-color: #fff;
		border-radius: 8px;
		box-shadow: 0 2px 10px rgba(0,0,0,0.05);
	}
</style>